import React from "react"
import styled from 'styled-components';

const SLAWrapper = styled.div`
.SLA  {

-webkit-tap-highlight-color: rgba(0,0,0,0);

a {
  background: 0 0;
  color: #4183C4;
  text-decoration: none;
}

.full-height-container {
  height: 66vh;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}

.container {
  margin-top: 56px;
  padding: 3% 5% 4% 5%;

  @media screen and (max-width: 39.9375em) {   
    padding: 10% 8%;
  }
}

h1 {
  color: #4183C4 !important;
  margin-bottom: 1.5rem;
  font-weight: 100;

  @media screen and (max-width: 39.9375em) {   
    font-size: 1.7rem;
  }
}

h2 {
  margin-bottom: 0.5rem;
  font-weight: 100;
  @media screen and (max-width: 39.9375em) {   
    font-size: 1.4rem;
  }
}

ul li {
  list-style-type: disc;
}

p, ul li, ol li {
  font-size: 15px;
  line-height: 1.7em;
}

table.ui.table {
  width: 100%;
  background: #FFF;
  margin: 1em 0;
  border: 1px solid rgba(34, 36, 38, .15);
  box-shadow: none;
  border-radius: .28571429rem;
  text-align: left;
  color: rgba(0, 0, 0, .87);
  border-collapse: separate;
  border-spacing: 0;
    
  tr td {
    padding: .78571429em;
    text-align: inherit;
    border-top: 1px solid rgba(34, 36, 38, .1);
    border-left: 1px solid rgba(34, 36, 38, .1);
  }

  tr:first-child td {
    border-top: none;
  }

  tr td:first-child {
    border-left: none;
  }
  

  /* tr:last-child {
    box-shadow: none!important;
  } */
}

ol.ordered-a {
  list-style-type: none;
  > li:before {
    content: " (" counter(section, lower-alpha) ") ";
  }
  > li { 
    counter-increment: section;
  }
  
}

ol.ordered-i {
  counter-reset:item;
  list-style:none;
  margin-left: 0.25rem;

  li:before        {
      content: " ("counter(item, lower-roman) ") ";
      counter-increment: item;
  }

}



}
`;

export default SLAWrapper;